import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ICheckStyle } from "../../../../documaker/domain/format/objects";

export interface ICheckStylePropertyEditable {
  checkStyle(): IPropertyEditable<ICheckStyle>;
}

export function instanceOfICheckStylePropertyEditable(instance: any): instance is ICheckStylePropertyEditable {
  return instance
      && instance.checkStyle
      && instanceOfIPropertyEditable<ICheckStyle>(instance.checkStyle());
}
